"use strict";
exports.__esModule = true;
exports.PREFILL_ADDRESS = void 0;
exports.PREFILL_ADDRESS = {
    BODY: 'Yay! We pre-filled your property address because your property is integrated with Flex.',
    BODY_UNIT_ONE: 'Yay! We pre-filled your property since ',
    BODY_UNIT_TWO: ' is integrated with Flex.',
    NOT_RIGHT: 'Not right?',
    START_OVER: 'Start over with a new address'
};
